import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import FormInput from '../../nuup/componentes/Forms/FormInput';
import Api from '../../api/global.service';
import Swal from 'sweetalert2';
import generalSuccessModal from '../modal/modal-success';
import { useHistory } from 'react-router-dom';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import FooterButtons from '../modal/footer-buttons';

const TextForm = ({
  initialValue,
  columnLabel,
  column,
  idCuenta,
  onClose,
  showModal,
  idForm,
  idParcela,
  setData = null,
  maxChar = 255,
}) => {
  let schema = yup.object().shape({
    textColumn: yup
      .string()
      .max(maxChar, `Máximo ${maxChar} caracteres`)
      .required('No se puede enviar un campo vacío'),
  });
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    mode: 'onBlur',
    defaultValues: {
      textColumn: initialValue,
    },
  });

  useEffect(() => {
    reset({
      textColumn: initialValue,
    });
    schema = yup.object().shape({
      textColumn: yup
        .string()
        .max(maxChar, `Máximo ${maxChar} caracteres`)
        .required('No se puede enviar un campo vacío'),
    });
  }, [showModal]);

  const onSubmit = values => {
    setLoading(true);
    const payload = {
      id_cuenta: idCuenta,
      new_value: values.textColumn,
      column: column,
      id_sic_informacion_general: idForm,
      id_parcela: idParcela,
    };

    Api.create(`admin/sic/padron_edit/${column}`, payload)
      .then(response => {
        const { success, message, data } = response.data;
        const finish = () => {
          if (setData) {
            setData(values.textColumn);
          } else {
            history.go(0);
          }
          onClose();
          setLoading(false);
        };
        generalSuccessModal(success, `${columnLabel} actualizado con éxito`, finish, message, data);
      })
      .catch(error => {
        // eslint-disable-next-line no-console
        console.log('error', error);
        const err = error.response.data;
        const errorMessage = err.errors?.['new_value'] !== undefined ? err.errors['new_value'] : err.errors?.message;
        setLoading(false);
        Swal.fire({
          icon: 'error',
          title: '',
          text: errorMessage ?? error?.response?.status,
        });
      });
  };

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      style={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}>
      <div className="modal-body">
        <div className="row my-4">
          <h4
            style={{
              textAlign: 'center',
              width: '100%',
            }}>
            {columnLabel}
          </h4>
          <div className="col-12">
            <FormInput
              id="textColumn"
              type="text"
              name="textColumn"
              // label={columnLabel}
              error={errors.textColumn}
              register={register}
            />
          </div>
        </div>
      </div>
      <div className="modal-footer">
        {loading && (
          <div className="spinner-border text-warning" role="status">
            <span className="sr-only">Guardando...</span>
          </div>
        )}
        {!loading && <FooterButtons onClose={onClose} />}
      </div>
    </form>
  );
};

export default TextForm;
